import React, { useEffect } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { isMobile } from "react-device-detect";
import Layout from "../../container/layout";
import EventHeader from "../../container/event/header";
import { initPage } from "./action";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { html_substr } from "../../utils";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
  headerAp: {
    fontWeight: 700,
    fontSize: isMobile ? "25px" : "32px",
    lineHeight: "56px",
    textAlign: "center",
    letterSpacing: "0.01em",
  },
  loginText: {
    fontSize: "36px",
    fontWeight: 700,
    lineHeight: "63px",
    textAlign: "center",
    letterSpacing: "0.01em",
  },
  titleSpace: {
    margin: 16,
  },
  button: {
    marginTop: 32,
    width: "264px",
    height: "48px",
    padding: "19px 56px",
    background: "#ffffff",
    border: "1px solid #C92028",
    color: "#C92028",
    boxShadow: "none",
    fontSize: 18,
  },
  textField: {
    width: "501px !important",
    margin: 32,
  },
  banner: {
    maxWidth: "1600px",
    margin: "0 auto",
    "& img": {
      maxWidth: "1600px",
      maxHeight: "450px",
      objectFit: "cover",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxHeight: "376px",
        objectFit: "cover",
      },
    },
  },
  leftContent: {
    textAlign: "left",
  },
  items: {
    fontFamily: "AP",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "32px",
  },
  registerButton: {
    maxWidth: "100%",
    [theme.breakpoints.up("xs")]: {
      padding: "12px 85px",
      width: "303px",
      height: "56px",
      fontSize: 18,
    },
    [theme.breakpoints.up("md")]: {
      padding: "19px 152px",
      width: "438px",
      height: "70px",
      fontSize: 24,
      marginTop: 64,
    },
  },
  bg: {
    width: "100%",
    backgroundImage: "url('/photo/bg.jpg')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center bottom",
    [theme.breakpoints.down("xs")]: {
      backgroundImage: "none",
    },
  },
  textDesc: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    color: "#585251",
    fontSize: 18,
    lineHeight: "32px",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      lineHeight: "28px",
    },
  },
  content: {
    padding: 16,
    fontSize: 18,
    lineHeight: "32px",
    boxSizing: "border-box",
    width: "100%",
    overflow: "hidden",
    fontFamily: "AP !important",
    "& img": {
      maxWidth: "100% !important",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      lineHeight: "28px",
    },
  },
  container: {
    [theme.breakpoints.down("md")]: {
      padding: 16,
    },
    [theme.breakpoints.up("md")]: {
      border: "1px solid #EFEFEF",
      padding: "50px 121px 50px 121px",
      boxSizing: "border-box",
    },
  },
}));

const Home = () => {
  const [state, setState] = React.useState({
    more: false,
    open: true,
    event: { banner_mobile: [], banner_desktop: [], eventTime: { endDate: false, isBetween: false, eventTimeNotYetStart: false } },
  });

  const classes = useStyles();
  const { eventid } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    initPage(state, setState, eventid, navigate);

    if (!!window.location.search) {
      window.localStorage.setItem("utm", window.location.search);
      window.localStorage.setItem("utm_ex", moment().add("30", "days").format());
    }
  }, []);

  // console.log(
  //   "between",
  //   moment(state.event.startdate_at).format("YYYY-MM-DD"),
  //   moment(state.event.enddate_at).format("YYYY-MM-DD"),
  //   moment(moment().format("YYYY-MM-DD"), "YYYY-MM-DD").format("YYYY-MM-DD"),
  //   moment(moment().format("YYYY-MM-DD"), "YYYY-MM-DD").isBetween(
  //     moment(state.event.startdate_at).format("YYYY-MM-DD"),
  //     moment(state.event.enddate_at).format("YYYY-MM-DD"),
  //     null,
  //     "[]"
  //   ),
  //   moment("2016-10-30").isBetween("2016-10-30", "2016-10-30", null, "[]")
  // );

  return (
    <div className={classes.bg}>
      <div className={classes.banner}>
        <img src={isMobile ? `${process.env.REACT_APP_API_URL}/images/${state.event.banner_mobile[0] || ""}` : `${process.env.REACT_APP_API_URL}/images/${state.event.banner_desktop[0] || ""}`} alt="" width="100%" />
      </div>
      <Layout>
        <div className={classes.container}>
          <EventHeader title={state.event.assetName} description={state.event.des2} />

          <Typography variant="subtitle1" className={clsx(classes.titleSpace, classes.textDesc)}>
            {state.event.asdescription}
          </Typography>

          {!!state.event.texteditor && (
            <div
              className={classes.content}
              dangerouslySetInnerHTML={{
                __html: state.more ? state.event.texteditor : "",
              }}
            />
          )}

          <div>
            <Grid item xs={12}>
              <center>
                {!state.more && state.event.texteditor ? (
                  <Button variant="contained" className={classes.button} onClick={() => setState({ ...state, more: true })}>
                    + ดูรายละเอียด
                  </Button>
                ) : (
                  <>
                    {state.event.eventTime.isRegister && (
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.registerButton}
                        onClick={() => {
                          navigate("/register/" + state.event.assetId + "/" + state.event.slugurl + window.location.search);
                        }}
                      >
                        ลงทะเบียน
                      </Button>
                    )}

                    {state.event.eventTime.eventTimeNotYetStart ? (
                      <Typography color="primary" component="h3" style={{ fontSize: 18, marginTop: 32 }}>
                        กิจกรรมนี้ยังไม่อยู่ในช่วงเวลาการรับสมัคร
                      </Typography>
                    ) : (
                      !state.event.eventTime.isRegister && (
                        <Typography color="primary" component="h3" style={{ fontSize: 18, marginTop: 32 }}>
                          หมดเวลารับสมัครแล้ว
                        </Typography>
                      )
                    )}
                  </>
                )}
              </center>
            </Grid>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Home;
